/*
 * cart-drawer-wishlist.js
 * Favoris « garder pour plus tard » du tiroir panier.
 *
 * Shopify n'a pas de liste de souhaits native : on garde un tableau de
 * variantes dans localStorage, avec un instantane du titre, du prix et de
 * l'image au moment de l'ajout (pas d'appel reseau a l'ouverture, et la liste
 * reste lisible meme hors ligne).
 *
 * Toute la logique tient dans ce fichier et dans l'objet window.CartDrawerFavoris
 * (lire / ajouter / retirer / rendre) : pour passer a une application de
 * wishlist plus tard, il suffit de reimplementer ces quatre methodes.
 *
 * Les libelles ne sont jamais ecrits ici : ils arrivent en parametres depuis
 * les reglages de la section (voir assets/cart-drawer.js).
 */
(() => {
  const CLE = 'records-favoris';

  function lire() {
    try {
      const brut = localStorage.getItem(CLE);
      const donnees = brut ? JSON.parse(brut) : [];
      return Array.isArray(donnees) ? donnees : [];
    } catch (e) {
      // Navigation privee, stockage bloque ou donnees corrompues : on rend une
      // liste vide plutot que de casser le tiroir.
      return [];
    }
  }

  function ecrire(liste) {
    try {
      localStorage.setItem(CLE, JSON.stringify(liste));
    } catch (e) {
      /* rien a faire : les favoris ne sont pas critiques */
    }
  }

  function ajouter(article) {
    if (!article || !article.variante) return;
    const liste = lire().filter((entree) => String(entree.variante) !== String(article.variante));
    liste.unshift(article);
    ecrire(liste);
  }

  function retirer(varianteId) {
    ecrire(lire().filter((entree) => String(entree.variante) !== String(varianteId)));
  }

  function echapper(valeur) {
    const noeud = document.createElement('span');
    noeud.textContent = valeur == null ? '' : String(valeur);
    return noeud.innerHTML;
  }

  function rendre(liste, libelles) {
    const articles = lire();

    if (articles.length === 0) {
      liste.innerHTML = `<li><p class="cart-drawer__wishlist-empty">${echapper(libelles.texteVide)}</p></li>`;
      return;
    }

    liste.innerHTML = articles
      .map((article) => {
        const image = article.image
          ? `<img class="cart-drawer__image" src="${echapper(article.image)}" alt="" loading="lazy" width="72" height="96">`
          : '';
        const variante =
          article.varianteTitre && article.varianteTitre !== 'Default Title'
            ? `<p class="cart-drawer__item-variant">${echapper(article.varianteTitre)}</p>`
            : '';

        return `
          <li class="cart-drawer__wishlist-item">
            <div class="cart-drawer__wishlist-media">${image}</div>
            <div class="cart-drawer__content">
              <a href="${echapper(article.url)}" class="cart-drawer__item-title">${echapper(article.titre)}</a>
              ${variante}
              <p class="cart-drawer__price"><span class="cart-drawer__price-current">${echapper(article.prix)}</span></p>
              <div class="cart-drawer__wishlist-actions">
                <button type="button" class="cart-drawer__wishlist-add" data-favori-ajouter data-variante="${echapper(
                  article.variante
                )}">${echapper(libelles.libelleAjouter)}</button>
                <button type="button" class="cart-drawer__wishlist-remove" data-favori-retirer data-variante="${echapper(
                  article.variante
                )}">${echapper(libelles.libelleRetirer)}</button>
              </div>
            </div>
          </li>`;
      })
      .join('');
  }

  window.CartDrawerFavoris = { lire, ajouter, retirer, rendre };
})();
